var _circle, _g, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.75 85.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.88,
    cy: 42.88,
    r: 42.88,
    fill: "#1eaff0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "page1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "g0-126",
    d: "M33.47,21.57c.43-1.73,1.21-4.58,1.21-5.19,0-.86-.18-1.47-4.32-1.47-1.21,0-2.08,0-2.08-.95,0-1.64.95-1.72,1.64-1.81,2.08-.17,8.91-.87,10.55-.87.69,0,1.21.26,1.21,1,0,.17-.78,3.2-1.21,4.76-.52,2.16-.52,2.33-1.13,4.49l-.51,2.16-4,15.9c4.93-6,10.11-6.57,12.79-6.57,6,0,9.94,3,9.94,9.34,0,4.84-3.89,15.21-5.36,19a19.38,19.38,0,0,0-1.47,6c0,1.82.52,2.85,2.16,2.85,2.34,0,6.23-1.9,8.73-10.71.43-1.3.43-1.56,1.3-1.56.26,0,1,0,1,.87,0,.51-3,13.31-11.33,13.31A6.82,6.82,0,0,1,45.57,65a11.2,11.2,0,0,1,1-4.23c1.55-4,5.53-14.52,5.53-19.88,0-2.85-.87-6-4.67-6-8.64,0-13.31,9.07-14,10.54-.09.26-.69,2.94-1.12,4.32-.26,1.3-1.13,4.58-1.39,5.88l-2,7.69c-.52,2.16-1.47,6.05-1.65,6.48a3.41,3.41,0,0,1-3.19,2.34,2.31,2.31,0,0,1-2.51-2.42,5.89,5.89,0,0,1,.35-2L33,23.73",
    fill: "#fff"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 26.67,
    y1: 26.83,
    x2: 62.83,
    y2: 16.5,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH);
export default __webpack_public_path__ + "static/media/h.278c63c0c2131fd78a34675fe7392add.svg";
export { ForwardRef as ReactComponent };